export const topPageId = 'scrolling';
export const bestSellingProductsSectionId = 'bestSellingProducts';
export const serviceSectionId = 'serviceSection';
export const productsOriginSectionId = 'productsOriginSection';
export const qualitySectionId = 'qualitySection';
export const accountSectionId = 'accountSection';
export const emailId = 'emailId';

export const scrollToId = (id: string): void => {
    setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
    }, 100);
}

export const scrollToTop = (id:string): void => {
    setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: "auto", block: "start", inline: "nearest" });
    }, 300);
}

export const scrollToTopSmooth = (id:string): void => {
    setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
    }, 300);
}